/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  deleteData,
  fetchData,
  postData,
  putData,
} from "@jda/lui-portal-utilities";
import { createRequestObject, getAuthToken } from "../utility/commonUtility";
import {
  ICreateApplicationRequest,
  IDeleteApplicationRequest,
  IEditApplicationRequest,
  IGetApplicationPayload,
} from "../models/Organizations/Application";

const { MANAGEMENT_SERVICE_URL } = window.env;

export const getAllApplications = async (
  applicationPayload: IGetApplicationPayload
) => {
  const { pageSize, pageNo, searchString, id } = applicationPayload;
  let apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/${id}/applications?page-number=${
    pageNo || 1
  }&page-size=${pageSize || 1000}`;
  apiURL = searchString ? `${apiURL}&filter-name=${searchString}` : apiURL;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const createNewApplication = async (data: ICreateApplicationRequest) => {
  const { name, description, organizationId, accountKey, contactEmail } = data;
  const apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/${organizationId}/applications`;
  return postData<any>(
    createRequestObject(apiURL),
    { name, description, accountKey, contactEmail },
    getAuthToken
  )
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateApplication = async (data: IEditApplicationRequest) => {
  const { name, description, organizationId, accountKey, contactEmail, id } =
    data;
  const apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/${organizationId}/applications/${id}`;
  return putData<any>(
    createRequestObject(apiURL),
    { name, description, contactEmail, accountKey },
    getAuthToken
  )
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteApplication = async (data: IDeleteApplicationRequest) => {
  const { organizationId, id } = data;
  const apiURL = `${MANAGEMENT_SERVICE_URL}/organizations/${organizationId}/applications/${id}`;
  return deleteData(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};
